import { defineMessages } from 'react-intl';

export default defineMessages({
  heading: {
    id: 'cookiePolicy_heading',
    defaultMessage: 'Zásady používání souborů cookies',
  },
});
